(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bios-block"]) return;
  try {
    
    $('.bio_link').hover(function() {
        $('.bio_block_content_row').hide();
        $('.bio_block_card').removeClass('active_bio');
        $('#bio_' + $(this).attr('data-name')).show();
        $(this).find('.bio_block_card').addClass('active_bio');
    });
    $('.collapse').on('hidden.bs.collapse', function () {
        $(this).parent().find('.accordion_status_icon').text('-');
    })
    $('.collapse').on('shown.bs.collapse', function () {
        $(this).parent().find('.accordion_status_icon').text('+');
    })
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-pages"] && !Shopify.designMode) return;
  try {
    
  function initializeSlickSlider() {
    $('#featured-pages_slides').slick({
      infinite: true,
      slidesToShow: 1.3,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.carousel-controls .carousel-prev'),
      nextArrow: $('.carousel-controls .carousel-next'),
      adaptiveHeight: false,
      centerMode: false,
      infinite: false
    });
  }

  function destroySlickSlider() {
    if ($('#featured-pages_slides').hasClass('slick-initialized')) {
      $('#featured-pages_slides').slick('unslick');
    }
  }

  function checkScreenWidth() {
    if (window.innerWidth <= 1024) {
      initializeSlickSlider();
    } else {
      destroySlickSlider();
    }
  }

  checkScreenWidth();

  $(window).on('resize', function() {
    checkScreenWidth();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-social-feed"] && !Shopify.designMode) return;
  try {
    
  $('#hg_social_feed_slides').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow: $('#hg-social-feed-info .carousel-prev'),
    nextArrow: $('#hg-social-feed-info .carousel-next'),
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-testimonials"] && !Shopify.designMode) return;
  try {
    
  $('#hg_testimonial_slides').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: $('.hg-testimonials .carousel-prev'),
    nextArrow: $('.hg-testimonials .carousel-next'),
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  $('#hg_testimonial_slides-new').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: true,
    prevArrow: $('.carousel-controls .carousel-prev'),
    nextArrow: $('.carousel-controls .carousel-next'),
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          centerMode: false,
          infinite: false,
          adaptiveHeight: false
        }
      }
    ]
  });


  } catch(e) { console.error(e); }
})();
})();
